import { Alert, Button, Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { API_BASE_URL, EDIT_HOSPITAL } from "../services/end_points";
import { _put } from "../services/service_api";

const EditHospital = ({ data }) => {
  const [editing] = useState(true);
  const [formData, setFormData] = useState({
    hospitalName: editing ? data.hospitalName : "",
  });
  const [alert, setAlert] = useState(null); // State to manage alert message
  useEffect(() => {
    setFormData({ hospitalName: data.hospitalName });
  }, [data]);
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const id = data.id;

    try {
      const res = await _put(`${API_BASE_URL}${EDIT_HOSPITAL}${id}`, formData);
      setFormData({ hospitalName: "" });

      if (res.status === 200) {
        setAlert(true);
      }
      window.location.reload();
    } catch (err) {
      setAlert(false);
      console.error("Error details:", err);

      if (err.response) {
        console.error("Server responded with status:", err.response.status);
        console.error("Response data:", err.response.data);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }
    }
  };

  const handleReset = () => {
    setFormData({ hospitalName: "" });
  };

  return (
    <>
      <Row>
        <Form onFinish={handleSubmit} layout="vertical">
          {alert && (
            <div>
              <Alert
                type="success"
                style={{
                  backgroundColor: "#dbffb8cf",
                  color: "black",
                  width: "100%",
                  marginTop: "0.5rem",
                  marginBottom: "2rem",
                }}
                message={"Hospital Updated!"}
              />
            </div>
          )}
          <Col
            md={20}
            xl={24}
            lg={24}
            sm={24}
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Form.Item label="Add Hospital Name" required>
              <Input
                id="HospitalName"
                name="hospitalName"
                value={formData.hospitalName}
                onChange={handleFormChange}
                style={{ width: "100%" }}
              />
            </Form.Item>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1rem", // Adjust spacing as needed
                width: "20vw",
              }}
            >
              <Button
                type="button"
                onClick={handleReset}
                style={{
                  color: "black",
                  border: "solid #1236fa",
                  marginRight: "auto",
                  width: "85px",
                  height: "32px",
                  borderRadius: "3vw",
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                onClick={handleSubmit}
                style={{
                  color: "white",
                  background: "#1236fa",
                  width: "85px",
                  height: "32px",
                  borderRadius: "3vw",
                }}
              >
                Submit
              </Button>
            </div>
          </Col>
        </Form>
      </Row>
    </>
  );
};
export default EditHospital;
